import template from './group.html';
import controller from './group.controller';
import './group.scss';

let groupComponent = {
  bindings: {},
  template,
  controller
};

export default groupComponent;



// WEBPACK FOOTER //
// ./client/app/components/group/group.component.js